export const FIELDS = {

  ID: 'id',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  NAME: 'name',
  SHIPPING_DAYS: 'shippingDays',
  SHIPPING_ACCOUNT: 'shippingAccount',
  Q_BSYNCED: 'qBSynced',
  Q_BSHIP_VIA_NAME: 'qBShipViaName',
  Q_BSHIP_VIA_LIST_ID: 'qBShipViaListID',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};